import { Box, IconButton, IconButtonProps, TooltipProps, TypographyProps, useTheme } from "@material-ui/core";
import LyfeTooltip, { LyfeTooltipProps } from "./LyfeTooltip";

interface IProps {
	isOn?: boolean;
	disabled?: boolean;
	canSelectDisabled?: boolean;
	onChange: (isOn: boolean) => void;
	iconOff: React.ReactElement;
	iconOn: React.ReactElement;
	tooltipPropsForIconOff?: TooltipPropsForSwitch;
	tooltipPropsForIconOn?: TooltipPropsForSwitch;
	boxStyle?: any;
}

type TooltipPropsForSwitch = Omit<TooltipProps, "children"> & { typographyProps?: TypographyProps } & LyfeTooltipProps;

interface ITooltipChildWrapper {
	iconButtonProps: IconButtonProps;
	children: React.ReactNode;
	tooltipProps?: TooltipPropsForSwitch;
}

const TooltipChildWrapper = (props: ITooltipChildWrapper) => {
	const { tooltipProps, children, iconButtonProps } = props;

	if (!tooltipProps) return <IconButton {...iconButtonProps}>{children}</IconButton>;

	return (
		<LyfeTooltip {...tooltipProps}>
			<div>
				<IconButton {...iconButtonProps}>{children}</IconButton>
			</div>
		</LyfeTooltip>
	);
};

export function Switch(props: IProps) {
	const { palette } = useTheme();

	const iconOffButtonProps = {
		disabled: (!props.isOn && !props.canSelectDisabled) || props.disabled,
		onClick: () => props.onChange(true),
		style: {
			padding: "4px 6px",
			marginRight: "5px",
			borderRadius: "4px",
			backgroundColor: props.isOn ? undefined : palette.background.paper,
		},
	};
	const iconOnButtonProps = {
		disabled: (props.isOn && !props.canSelectDisabled) || props.disabled,
		onClick: () => props.onChange(false),
		style: { padding: "4px 6px", borderRadius: "4px", backgroundColor: props.isOn ? palette.background.paper : undefined },
	};

	return (
		<Box display="flex" borderRadius="4px" padding={0.8} style={{ backgroundColor: "#f5f8f9", ...props.boxStyle }}>
			<TooltipChildWrapper iconButtonProps={iconOffButtonProps} tooltipProps={props.tooltipPropsForIconOff}>
				{props.iconOff}
			</TooltipChildWrapper>
			<TooltipChildWrapper iconButtonProps={iconOnButtonProps} tooltipProps={props.tooltipPropsForIconOn}>
				{props.iconOn}
			</TooltipChildWrapper>
		</Box>
	);
}
